import { createFileRoute } from '@tanstack/react-router';

import { AccountProfilePage } from '@pages/account';

export const Route = createFileRoute('/$locale/_authenticated/account')({
  component: AccountProfilePage,
});
